import { defineComponent as _defineComponent } from 'vue'
import { global_set, global_set_json } from '@/utils';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import chapterApi from '@/api/chapter';
import { mangaInfoType } from '@/type/manga';
import imageApi from '@/api/image';
import { onMounted, onActivated } from 'vue';
import queue from '@/store/quque';
import usePosterStore from '@/store/poster';

type mangaItemType = mangaInfoType & { blob: string; mangaCover: string; };


const __default__ = {
	name: 'manga-list-item'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['mangaInfo', 'viewType'],
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();
const poster: any = usePosterStore();
// 传值
const props = __props;
const placeholder = require('@/assets/s-blue.png');
const fit = 'cover';

let blobLink = ref('');

const mangaName = computed(() => {
	if (route.name === 'media-list') return props.mangaInfo.chapterName;
	return props.mangaInfo.mangaName;
})

onMounted(() => {
	queue.mangaQueue.add(() => get_poster(props.mangaInfo));
})

async function get_poster(item: mangaItemType) {
	const coverName = item.mangaCover;
	if (poster[coverName]) {
		blobLink.value = poster[coverName]
	} else {
		blobLink.value = await imageApi.get(coverName);
		poster[coverName] = blobLink.value;
	}
}

async function go_chapter() {
	const mangaInfo = props.mangaInfo;

	const mangaId = mangaInfo.mangaId;
	const mangaCover = mangaInfo.mangaCover;
	const chapterId = mangaInfo.chapterId;
	const chapterName = mangaInfo.chapterName;
	const browseType = mangaInfo.browseType;
	const removeFirst = mangaInfo.removeFirst;
	const direction = mangaInfo.direction;
	const page = mangaInfo.page;
	// 缓存漫画信息
	global_set('mangaId', mangaId);
	global_set('mangaName', mangaName);
	global_set('mangaCover', mangaCover);
	global_set('chapterId', chapterId);
	global_set('chapterName', chapterName);
	global_set('removeFirst', removeFirst);
	global_set('direction', direction);

	if (route.name === 'media-list') {

		const chapterListRes = await chapterApi.get(mangaId);
		const chapterList = chapterListRes.list;
		global_set_json('chapterList', chapterList);

		router.push({
			name: browseType,
			query: { chapterId: mangaInfo.chapterId },
			params: { page },
		});
		return;
	}

	router.push({
		name: 'manga-info',
		query: { mangaId },
		params: { browseType, clear: '1' },
	});
}

const __returned__ = { route, router, poster, props, placeholder, fit, get blobLink() { return blobLink }, set blobLink(v) { blobLink = v }, mangaName, get_poster, go_chapter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})